import { toastPool } from '../features/toasts/models/toast-pool';
import { Toast } from '../features/toasts/models/toast';

const DEFAULT_MESSAGE = 'An unexpected error occurred, try again later.';

/**
 * `message` lets a caller replace the generic toast with something specific to the action that
 * failed. The server's own `message` is deliberately not surfaced: it is written for developers
 * ("Property not found") and tells the user nothing they can act on.
 */
export const catchError = (e: any, message: string = DEFAULT_MESSAGE) => {
  if (!(e.response?.status === 401)) {
    toastPool.insert(new Toast(message, 'error'));
  }
};
